
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import ResourceModel from "@/models/createTicket/ResourceModel";
import ResourceViewModel from "@/models/createTicket/ResourceViewModel";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.id);
        this.getHistory(this.$route.params.id);
    }
    utils = utils;
    titlePage = "Assessment Report";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";
    ticket1: WorkorderModel = new WorkorderModel();
    isActiveDesc = false;

    step = 0;

    history = [];
    listImage: AttachmentModel[] = [];

    resource: ResourceViewModel = new ResourceViewModel();
    note = null;

    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getResource(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.resource = response.data.data;
                        this.getDetailWorkorder(this.resource?.workorder?.id);

                        const verificator = this.resource?.verificator;
                        if (verificator) {
                            const ver = JSON.parse(verificator ?? '{}');
                            const vers = Object.values(ver).filter((e:any) => e.status === 'Rejected');
                            const verss : any = vers[vers.length - 1];
                            if(verss){
                                if (verss.hasOwnProperty("note")) {
                                    this.note = verss["note"];
                                }
                            }
                        }
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getDetailWorkorder(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket1 = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getHistory(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getHistory(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.history = response.data.data;
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    get colorStatus() {
        if (this.resource?.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.resource?.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}
